export const taskSites_ecr_rd = [
  {id: '1', data: {"1":"АКЦИОНЕРНОЕ ОБЩЕСТВО 'ТОРГОВЫЙ ДОМ 'ПЕРЕКРЕСТОК'",	"2":"АО 'ТОРГОВЫЙ ДОМ 'ПЕРЕКРЕСТОК'",	"3":"1027700034493",	"4":"7728029110",	"5":"772201001",	"6":"109029, г. Москва, ул. Средняя Калитниковская, дом 28, строение 4",	"7":"В128",	"8":"Академика Варги 8",	"9":"4606038214950",	"10":"",	"11":"",	"12":"",	"13":"",	"14":"",	"15":"г. Москва",	"16":"г. Москва",	"17":"ул. Академика Варги, д. 8 к.1",	"18":"55.630089",	"19":"37.47409",	"20":"117133, г. Москва, г.Москва, Академика Варги ул 8 к.1",	"21":"",	"22":"",	"23":"Supermarket",	"24":"Supermarket",	"25":"",	"26":"",	"27":"",	"28":"",	"29":"",	"30":"",	"31":"",	"32":"",	"33":"Открыт ",	"34":"",	"35":"",	"36":""}, schema: {
      "id": "3",
      "schemaId": "1",
      "isActual": true,
      "name": "Основная схема сайтов",
      "type": "site",
      "version": "3",
      "dateCreate": "2020-05-13T08:24:58.188Z",
      "dateUpdate": "2020-05-13T08:24:58.188Z",
      "elementsCount": 20,
      "pages": [{
        "id": "0",
        "name": "Лист 1",
        "groups": [{
          "id": "1",
          "name": "Юридическое лицо",
          "elements": [{
            "id": "1",
            "code": "1",
            "name": "Название ЮЛ",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Текстовое поле, \"кавычки-елочки\" запрещены",
            "public": false
          }, {
            "id": "2",
            "code": "2",
            "name": "Краткое название ЮЛ",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Текстовое поле, \"кавычки-елочки\" запрещены",
            "public": false
          }, {
            "id": "3",
            "code": "3",
            "name": "ОГРН/ОГРНИП",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовой, 13-15 цифр",
            "public": false
          }, {
            "id": "4",
            "code": "4",
            "name": "ИНН",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовой, 10 для организаций, 12 для ИП и физических лиц",
            "public": false
          }, {
            "id": "5",
            "code": "5",
            "name": "КПП",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовой, 9 цифр, неприменимо для ИП и физических лиц",
            "public": false
          }, {
            "id": "6",
            "code": "6",
            "name": "Юр. адрес",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)",
            "public": false
          }]
        }, {
          "id": "2",
          "name": "Идентификаторы",
          "elements": [{
            "id": "7",
            "code": "7",
            "name": "Внутрениий номер магазина",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Маска: \"Магазин №…\" если применимо",
            "public": false
          }, {
            "id": "8",
            "code": "8",
            "name": "Внутреннее имя магазина",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Текстовое поле",
            "public": false
          }, {
            "id": "9",
            "code": "9",
            "name": "GLN магазина",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовой, 13 цифр",
            "public": false
          }, {
            "id": "10",
            "code": "10",
            "name": "GLN РЦ",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовой, 13 цифр",
            "public": false
          }, {
            "id": "11",
            "code": "11",
            "name": "GUID (Меркурий)",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "12",
            "code": "12",
            "name": "ЕГАИС",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовой, до 9-11 цифр",
            "public": false
          }, {
            "id": "13",
            "code": "13",
            "name": "Логистический филиал",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "14",
            "code": "14",
            "name": "Единый сквозной идентификатор",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }]
        }, {
          "id": "3",
          "name": "География",
          "elements": [{
            "id": "15",
            "code": "15",
            "name": "Регион",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Выбор из классификатора ФИАС",
            "public": false
          }, {
            "id": "16",
            "code": "16",
            "name": "Населенный пункт",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Выбор из классификатора ФИАС",
            "public": false
          }, {
            "id": "17",
            "code": "17",
            "name": "Адрес местонахождения",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)",
            "public": false
          }, {
            "id": "18",
            "code": "18",
            "name": "Широта",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовое поле с маской ***,******",
            "public": false
          }, {
            "id": "19",
            "code": "19",
            "name": "Долгота",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовое поле с маской ***,******",
            "public": false
          }, {
            "id": "20",
            "code": "20",
            "name": "География ритейлера",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "21",
            "code": "21",
            "name": "Код ФИАС",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Текстовое поле",
            "public": false
          }, {
            "id": "22",
            "code": "22",
            "name": "Уровень по ФИАС",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }]
        }, {
          "id": "4",
          "name": "Торговые параметры",
          "elements": [{
            "id": "23",
            "code": "23",
            "name": "Формат по каналу",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "24",
            "code": "24",
            "name": "Формат по площади",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "25",
            "code": "25",
            "name": "Торговая площадь",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "26",
            "code": "26",
            "name": "Трафик",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "27",
            "code": "27",
            "name": "Режим работы",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "28",
            "code": "28",
            "name": "Список представленных категорий",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "29",
            "code": "29",
            "name": "Длина полок в каждой категории",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "30",
            "code": "30",
            "name": "Планограмма выкладки",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "31",
            "code": "31",
            "name": "Ассортиментная емкость",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "32",
            "code": "32",
            "name": "Количество касс",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }]
        }, {
          "id": "5",
          "name": "Статус",
          "elements": [{
            "id": "33",
            "code": "33",
            "name": "Текущий статус",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "34",
            "code": "34",
            "name": "Дата открытия",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "35",
            "code": "35",
            "name": "Дата открытия заказов",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "36",
            "code": "36",
            "name": "Дата закрытия",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "37",
            "code": "37",
            "name": "Расписание реконструкций",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }]
        }, {
          "id": "6",
          "name": "Контактные данные",
          "elements": [{
            "id": "38",
            "code": "38",
            "name": "Имя директора",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "39",
            "code": "39",
            "name": "Телефон",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "40",
            "code": "40",
            "name": "e-mail",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }]
        }, {
          "id": "7",
          "name": "Логистические параметры",
          "elements": [{
            "id": "42",
            "code": "42",
            "name": "Возможность совмещения несколько ттн в одном авто (РЦ)",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "43",
            "code": "43",
            "name": "Время обслуживания для выгрузки в секундах",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "44",
            "code": "44",
            "name": "Время обслуживания для приемки в секундах",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "45",
            "code": "45",
            "name": "Высота рампы на РЦ, м",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "46",
            "code": "46",
            "name": "Допустимый свес продукции с поддона, см",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "47",
            "code": "47",
            "name": "Каждая партия на отдельном поддоне",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "48",
            "code": "48",
            "name": "Каждая партия отдельным слоем на поддоне",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "49",
            "code": "49",
            "name": "Каждая партия отдельным столбиком на поддоне",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "50",
            "code": "50",
            "name": "Каждый SKU отдельным слоем",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "51",
            "code": "51",
            "name": "Каждый SKU отдельным столбиком",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "52",
            "code": "52",
            "name": "Максимальная высота поддона, м",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "53",
            "code": "53",
            "name": "Максимальный вес поддона, кг",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "54",
            "code": "54",
            "name": "Необходимость заказа пропуска в закрытые города",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "55",
            "code": "55",
            "name": "Необходимость заказа пропуска на движение грузовых авто",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "56",
            "code": "56",
            "name": "Необходимость упаковочного / информационного листа",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "57",
            "code": "57",
            "name": "Радиус доставки",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "58",
            "code": "58",
            "name": "Требования к внешнему виду водителя - обувь",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "59",
            "code": "59",
            "name": "Требования к внешнему виду водителя - одежда",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "60",
            "code": "60",
            "name": "Требования к внешнему виду водителя - санитарная книжка",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "61",
            "code": "61",
            "name": "Требования к поддонам - американские поддоны",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "62",
            "code": "62",
            "name": "Требования к поддонам - синие поддоны",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "63",
            "code": "63",
            "name": "Требования к транспорту - наличие гидролифта",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "64",
            "code": "64",
            "name": "Требования к транспорту - наличие пневподвеса",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }]
        }]
      }]
    }},
  {id: '2',
    data:{"1":"АКЦИОНЕРНОЕ ОБЩЕСТВО 'ТОРГОВЫЙ ДОМ 'ПЕРЕКРЕСТОК'",	"2":"АО 'ТОРГОВЫЙ ДОМ 'ПЕРЕКРЕСТОК'",	"3":"1027700034493",	"4":"7728029110",	"5":"772201001",	"6":"109029, г. Москва, ул. Средняя Калитниковская, дом 28, строение 4",	"7":"В127",	"8":"Каховка 27",	"9":"4606038215018",	"10":"",	"11":"",	"12":"",	"13":"",	"14":"",	"15":"г. Москва",	"16":"г. Москва",	"17":"ул. Каховка, д.27",	"18":"55.655353",	"19":"37.57269",	"20":"117461, г. Москва, г.Москва, Каховка ул 27",	"21":"",	"22":"",	"23":"Supermarket",	"24":"Supermarket",	"25":"",	"26":"",	"27":"",	"28":"",	"29":"",	"30":"",	"31":"",	"32":"",	"33":"Открыт ",	"34":"",	"35":"",	"36":""}, schema: {
      "id": "3",
      "schemaId": "1",
      "isActual": true,
      "name": "Основная схема сайтов",
      "type": "site",
      "version": "3",
      "dateCreate": "2020-05-13T08:24:58.188Z",
      "dateUpdate": "2020-05-13T08:24:58.188Z",
      "elementsCount": 20,
      "pages": [{
        "id": "0",
        "name": "Лист 1",
        "groups": [{
          "id": "1",
          "name": "Юридическое лицо",
          "elements": [{
            "id": "1",
            "code": "1",
            "name": "Название ЮЛ",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Текстовое поле, \"кавычки-елочки\" запрещены",
            "public": false
          }, {
            "id": "2",
            "code": "2",
            "name": "Краткое название ЮЛ",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Текстовое поле, \"кавычки-елочки\" запрещены",
            "public": false
          }, {
            "id": "3",
            "code": "3",
            "name": "ОГРН/ОГРНИП",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовой, 13-15 цифр",
            "public": false
          }, {
            "id": "4",
            "code": "4",
            "name": "ИНН",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовой, 10 для организаций, 12 для ИП и физических лиц",
            "public": false
          }, {
            "id": "5",
            "code": "5",
            "name": "КПП",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовой, 9 цифр, неприменимо для ИП и физических лиц",
            "public": false
          }, {
            "id": "6",
            "code": "6",
            "name": "Юр. адрес",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)",
            "public": false
          }]
        }, {
          "id": "2",
          "name": "Идентификаторы",
          "elements": [{
            "id": "7",
            "code": "7",
            "name": "Внутрениий номер магазина",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Маска: \"Магазин №…\" если применимо",
            "public": false
          }, {
            "id": "8",
            "code": "8",
            "name": "Внутреннее имя магазина",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Текстовое поле",
            "public": false
          }, {
            "id": "9",
            "code": "9",
            "name": "GLN магазина",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовой, 13 цифр",
            "public": false
          }, {
            "id": "10",
            "code": "10",
            "name": "GLN РЦ",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовой, 13 цифр",
            "public": false
          }, {
            "id": "11",
            "code": "11",
            "name": "GUID (Меркурий)",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "12",
            "code": "12",
            "name": "ЕГАИС",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовой, до 9-11 цифр",
            "public": false
          }, {
            "id": "13",
            "code": "13",
            "name": "Логистический филиал",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "14",
            "code": "14",
            "name": "Единый сквозной идентификатор",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }]
        }, {
          "id": "3",
          "name": "География",
          "elements": [{
            "id": "15",
            "code": "15",
            "name": "Регион",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Выбор из классификатора ФИАС",
            "public": false
          }, {
            "id": "16",
            "code": "16",
            "name": "Населенный пункт",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Выбор из классификатора ФИАС",
            "public": false
          }, {
            "id": "17",
            "code": "17",
            "name": "Адрес местонахождения",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)",
            "public": false
          }, {
            "id": "18",
            "code": "18",
            "name": "Широта",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовое поле с маской ***,******",
            "public": false
          }, {
            "id": "19",
            "code": "19",
            "name": "Долгота",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Числовое поле с маской ***,******",
            "public": false
          }, {
            "id": "20",
            "code": "20",
            "name": "География ритейлера",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "21",
            "code": "21",
            "name": "Код ФИАС",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "Текстовое поле",
            "public": false
          }, {
            "id": "22",
            "code": "22",
            "name": "Уровень по ФИАС",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }]
        }, {
          "id": "4",
          "name": "Торговые параметры",
          "elements": [{
            "id": "23",
            "code": "23",
            "name": "Формат по каналу",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "24",
            "code": "24",
            "name": "Формат по площади",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "25",
            "code": "25",
            "name": "Торговая площадь",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "26",
            "code": "26",
            "name": "Трафик",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "27",
            "code": "27",
            "name": "Режим работы",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "28",
            "code": "28",
            "name": "Список представленных категорий",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "29",
            "code": "29",
            "name": "Длина полок в каждой категории",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "30",
            "code": "30",
            "name": "Планограмма выкладки",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "31",
            "code": "31",
            "name": "Ассортиментная емкость",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "32",
            "code": "32",
            "name": "Количество касс",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }]
        }, {
          "id": "5",
          "name": "Статус",
          "elements": [{
            "id": "33",
            "code": "33",
            "name": "Текущий статус",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "34",
            "code": "34",
            "name": "Дата открытия",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "35",
            "code": "35",
            "name": "Дата открытия заказов",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "36",
            "code": "36",
            "name": "Дата закрытия",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "37",
            "code": "37",
            "name": "Расписание реконструкций",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }]
        }, {
          "id": "6",
          "name": "Контактные данные",
          "elements": [{
            "id": "38",
            "code": "38",
            "name": "Имя директора",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "39",
            "code": "39",
            "name": "Телефон",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "40",
            "code": "40",
            "name": "e-mail",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }]
        }, {
          "id": "7",
          "name": "Логистические параметры",
          "elements": [{
            "id": "42",
            "code": "42",
            "name": "Возможность совмещения несколько ттн в одном авто (РЦ)",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "43",
            "code": "43",
            "name": "Время обслуживания для выгрузки в секундах",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "44",
            "code": "44",
            "name": "Время обслуживания для приемки в секундах",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "45",
            "code": "45",
            "name": "Высота рампы на РЦ, м",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "46",
            "code": "46",
            "name": "Допустимый свес продукции с поддона, см",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "47",
            "code": "47",
            "name": "Каждая партия на отдельном поддоне",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "48",
            "code": "48",
            "name": "Каждая партия отдельным слоем на поддоне",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "49",
            "code": "49",
            "name": "Каждая партия отдельным столбиком на поддоне",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "50",
            "code": "50",
            "name": "Каждый SKU отдельным слоем",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "51",
            "code": "51",
            "name": "Каждый SKU отдельным столбиком",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "52",
            "code": "52",
            "name": "Максимальная высота поддона, м",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "53",
            "code": "53",
            "name": "Максимальный вес поддона, кг",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "54",
            "code": "54",
            "name": "Необходимость заказа пропуска в закрытые города",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "55",
            "code": "55",
            "name": "Необходимость заказа пропуска на движение грузовых авто",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "56",
            "code": "56",
            "name": "Необходимость упаковочного / информационного листа",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "57",
            "code": "57",
            "name": "Радиус доставки",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "58",
            "code": "58",
            "name": "Требования к внешнему виду водителя - обувь",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "59",
            "code": "59",
            "name": "Требования к внешнему виду водителя - одежда",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "60",
            "code": "60",
            "name": "Требования к внешнему виду водителя - санитарная книжка",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "61",
            "code": "61",
            "name": "Требования к поддонам - американские поддоны",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "62",
            "code": "62",
            "name": "Требования к поддонам - синие поддоны",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "63",
            "code": "63",
            "name": "Требования к транспорту - наличие гидролифта",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }, {
            "id": "64",
            "code": "64",
            "name": "Требования к транспорту - наличие пневподвеса",
            "type": "string",
            "length": 50,
            "showHint": false,
            "hint": "",
            "public": false
          }]
        }]
      }]
    }}

];



